// Color palette keyed by statistical_category
export const CATEGORY_COLORS = {
  vacation: '#4caf50',       // green  — ferie
  sickleave: '#f44336',      // red    — sygdom
  leave: '#9c27b0',          // purple — barsel / orlov
  personal: '#ff9800',       // orange — børneomsorgsdage
  attendance: '#2196f3',     // blue   — normaltid
};

// Color keyed by work_time_type
export const CODE_COLORS = {
  work: '#2196f3',
  absence: '#f44336',
  pause: '#e0e0e0',
};

// Color overrides keyed by registration_category — takes precedence over statistical/work_time
export const REGISTRATION_CATEGORY_COLORS = {
  overtime_voluntary: '#ffc107',  // amber — merarbejde
  overtime_forced: '#ffc107',     // amber — overarbejde
  overtime_holiday: '#ffc107',    // amber — overarbejde (helligdag)
};

export const DEFAULT_COLOR = '#9e9e9e';
export const SHIFT_COLOR = '#42a5f5';  // lighter blue for planned shift band
